<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <template v-slot:activator="{ on }">
    </template>
    <v-card>
      <v-card-title class="headline">{{$t('saveChanges')}}</v-card-title>
      <v-card-text>{{$t('unsaved')}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          autofocus
          @click="response(false)"
        >{{$t('discard')}}</v-btn>
        <v-btn color="primary" text @click="response(true)">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    dialog: Boolean
  },
  data() {
    return {
    };
  },
  methods: {
   response(answer)
   {
       this.$emit("response",answer);
       //this.dialog = false;
   }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SaveBeforeLeave.vue